import { DesignClass } from "@app/types";
import { createUuid } from '@app/utilities';
import BaseComponent from "../BaseComponent";
import OldInput from "../OldInput";
import Button from "../Button";
import { Constant } from '../../const';
import DesignerSetting from "../../DesignerSetting";

export default class KeyValueSubCon extends BaseComponent {
   
   
    /**
     * Submenu view for key-value item lists
     * @module KeyValueSubCon
     * @param {Object} props React props
     */
    constructor(props){
        super(props);
        // Data model
        this.varModel = (this.props.data && this.props.data.keyValue) ? this.props.data.keyValue : this.initVarModel();
        // List index for this item
        this.varIdx = (this.props.data && this.props.data.varIdx) ? this.props.data.varIdx : 0;
    }

    /**
     * Initialize a dummy data model
     * @returns {Object}
     */
    initVarModel(){
        return {
            id: createUuid(),
            key: null,
            value: null
        };
    }
    validateAndCreateVariable(){
        const treeDom = $('#tl_container');
        if (this.varModel.key){
            var sv = this.varModel.key.split(".");
            if (sv.length > 1 && sv[0] === Constant.k.SCOPE_CONVERSATION){
                const v = window.apm.getVariable(sv[1]);
                if (!v){
                    let newVariable = this.getVariableProps(sv[1]);
                    treeDom.jstree().create_node("variables", Utility.getTreeNode(newVariable), "last");
                    window.apm.addNode(newVariable, false);
                    window.apm.refreshApplicationTree();
                }
            }
            else if (sv.length === 1 && sv[0] !== Constant.k.SCOPE_CONVERSATION){
                const v = window.apm.getVariable(sv[0]);
                if (!v){
                    let newVariable = this.getVariableProps(sv[0]);
                    treeDom.jstree().create_node("variables", Utility.getTreeNode(newVariable), "last");
                    window.apm.addNode(newVariable, false);
                   window.apm.refreshApplicationTree();
                }
            }
        }
    }
    getVariableProps(varName)  {
        const variable={
            name: varName,
            type:"variable",
            _class: DesignClass.variable,
            id:createUuid(),
            props:{
                config:{
                    defaultValue: "",
                    description: "",
                    disabledInFlow: false,
                    scope: "conversation",
                    sensitiveData: false,
                    type: "STRING",
                    varName: varName
                },
                lastLocalChange:window.apm.timestamp,
                createdTime: window.apm.timestamp,
                author: DesignerSetting.s.author,
                colorClass: "pink",
                iconClass: "hash",
            }
        }
        return variable;
        
};
    /**
     * Set config proxy; catches own input value updates and update its data model before saving to list
     * @param {string} key
     * @param {string} value
     */
    setConfig(key, value){
        this.varModel[key] = value;
    }
    getConfig(key){
        return this.varModel[key];
    }
    /**
     * React render
     * @returns {XML}
     */
    render() {
        const keyText = this.props.params.keyText ? this.props.params.keyText : this.getPropLabel("key");
        const valText = this.props.params.valText ? this.props.params.valText : this.getPropLabel("value");
        return (
            <div>
                {<OldInput label={keyText} 
                    hint={keyText}
                        context={this} 
                        valKey={"key"} 
                        value={this.varModel["key"]} 
                        suggestion={this.props.context.props.suggestion}
                        keyType={this.props.context.props.keyType}
                        autoCompleteConversationVariable = {this.props.context.props.label === "Conversational Variables"}/>}
                {<OldInput label={valText} 
                        hint={valText}
                        context={this} 
                        valKey={"value"} 
                        suggestion={"variable"} 
                        value={this.varModel["value"]} />}
                {(() => {
                    return (
                        <Button label={this.getPropLabel("add")} wide={true}
                                callback={() => {
                                    if (this.varModel && this.varModel.key) {
                                        // Add current data model to item list
                                        this.validateAndCreateVariable(this.varModel);
                                        this.props.context.add(this.varModel);
                                    }
                                    // Reset and close
                                    this.props.domContext.removeSubmenu();
                                }}
                        />
                    );
                })()}
            </div>
        );
    }
}